import type {RouteRecordRaw} from "vue-router";

export const routeName = 'CreateDocument';

export const route: RouteRecordRaw = {
    name: routeName,
    path: 'create',
    component: () => import('@/pages/CreateDocument'),
    meta: {
        isHide: true,
    }
};